import config from '../utils/ApiUrl';
import { getCookie, handleSessionExpire } from './session';

const API_URL = config.API_URL;

const fetchAllBlogs = async () => {
  const sessionToken = getCookie();
  if (!sessionToken) return handleSessionExpire();

  const response = await fetch(`${API_URL}/fetch-blogs`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${sessionToken}`,
    },
  });
  const data = await response.json();
  return data.session ? handleSessionExpire() : data;
};

const addBlog = async (formData, password) => {
  const sessionToken = getCookie();
  if (!sessionToken) return handleSessionExpire();

  const response = await fetch(`${API_URL}/add-blog/${password}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${sessionToken}`,
    },
    body: JSON.stringify(formData),
  });
  const data = await response.json();
  return data.session ? handleSessionExpire() : data;
};

const deleteBlog = async (blogId, password) => {
  const sessionToken = getCookie();
  if (!sessionToken) return handleSessionExpire();

  const response = await fetch(`${API_URL}/delete-blog/${password}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${sessionToken}`,
    },
    body: JSON.stringify({ blogId: blogId }),
  });
  const data = await response.json();
  return data.session ? handleSessionExpire() : data;
};

const uploadImages = async (password, images, blogUrl) => {
  const sessionToken = getCookie();
  if (!sessionToken) return handleSessionExpire();

  const formData = new FormData();
  const base64Images = images.filter((image) => !isS3Url(image));

  if (base64Images.length === 0) {
    return { images: images };
  }

  base64Images.forEach((image, index) => {
    const blob = base64ToBlob(image);
    formData.append('images', blob, `image-${index}.jpg`);
  });

  formData.append('blogUrl', blogUrl);

  try {
    const response = await fetch(`${API_URL}/upload-blog-images/${password}`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${sessionToken}`,
      },
      body: formData,
    });

    if (!response.ok) {
      return { error: 'Image upload failed' };
    }

    const data = await response.json();
    const updatedImages = replaceImagesWithS3Urls(images, data.images);

    return { images: updatedImages };
  } catch {
    return { error: 'Image upload failed' };
  }
};

const isS3Url = (url) => {
  return /^https:\/\/.*\.s3\.amazonaws\.com\/.*$/.test(url);
};

const replaceImagesWithS3Urls = (originalImages, s3Urls) => {
  let s3Index = 0;
  return originalImages.map((image) => {
    if (isS3Url(image)) return image;
    return s3Urls[s3Index++] || '/empty.png';
  });
};

const base64ToBlob = (base64String) => {
  const byteString = atob(base64String.split(',')[1]);
  const mimeString = base64String.split(',')[0].split(':')[1].split(';')[0];

  const byteArray = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) {
    byteArray[i] = byteString.charCodeAt(i);
  }

  return new Blob([byteArray], { type: mimeString });
};

export { fetchAllBlogs, addBlog, deleteBlog, uploadImages };
